import * as React from 'react';
import { Button, Grid } from '@mui/material';
import { Modal, Typography, Form, Input } from 'antd';
import { primaryColor, whiteColor } from '../../Utils/Constants';
import { FormattedMessage } from 'react-intl';
import TextArea from 'antd/es/input/TextArea';
import { useState } from 'react';

const ModalDescription = (props) => {
    const [form] = Form.useForm();
    const { modalOpen, setModalOpen, description, setDescription, setId, setSearchParams, handleUpdateDescription, data = {} } = props;
    React.useEffect(() => {
        form.setFieldsValue({
            deliveryFee: data.deliveryFee,
            pickupFee: data.pickupFee,
            rentPurpose: data.description ? data.description.rentPurpose : '',
            emergencyPhoneNumber: data.description ? data.description.emergencyPhoneNumber : '',
            email: data.email,
            location: data.location,
            socialMedia: data.socialMedia,
            officeName: data.description ? data.description.officeName : '',
            helm: data.description ? data.description.helm : '',
            rainCoat: data.description ? data.description.rainCoat : '',
            odometer: data.description ? data.description.odometer : '',
            barPetrol: data.description ? data.description.barPetrol : '',
            description: data.description
        })
    }, [data])

    const onClose = () => {
        if (setId) {
            setId(null)
        }
        setModalOpen(false)
        if (setSearchParams) {
            setSearchParams(new FormData())
        }
    }

    return (
        <Modal
            // title="Vertically centered modal dialog"
            centered
            open={modalOpen}
            onOk={() => onClose()}
            onCancel={() => onClose()}
            width={800}
            footer={[
                <Button style={{ backgroundColor: whiteColor, color: primaryColor }} variant="contained" key="back" onClick={() => onClose()}>
                    Kembali
                </Button>,
                <Button style={{ backgroundColor: primaryColor, color: whiteColor, marginLeft: '20px' }} variant="contained" key="submit" type="primary" onClick={handleUpdateDescription}>
                    <FormattedMessage id="updateDescription" />
                </Button>
            ]}
        >
            <div style={{ paddingTop: "20px" }}>
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Form.Item name={'deliveryFee'} label={'Delivery Fee'}>
                                <Input value={data.deliveryFee} disabled />
                            </Form.Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Form.Item name={'pickupFee'} label={'Pickup Fee'}>
                                <Input value={data.pickupFee} disabled />
                            </Form.Item>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Form.Item name={'rentPurpose'} label={'Rent Purpose'}>
                                <Input value={data.rentPurpose} disabled />
                            </Form.Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Form.Item name={'emergencyPhoneNumber'} label={'Emergency'}>
                                <Input value={data.emergencyPhoneNumber} disabled />
                            </Form.Item>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Form.Item name={'email'} label={'Email'} >
                                <Input value={data.email} disabled />
                            </Form.Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Form.Item name={'location'} label={'Address'}>
                                <TextArea value={data.location} disabled />
                            </Form.Item>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Form.Item name={'socialMedia'} label={'Social Media'}>
                                <Input value={data.socialMedia} disabled />
                            </Form.Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Form.Item name={'officeName'} label={'Office Name'}>
                                <Input value={data.officeName} disabled />
                            </Form.Item>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Form.Item name={'helm'} label={'Helm'}>
                                <Input value={data.helm} disabled />
                            </Form.Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Form.Item name={'rainCoat'} label={'Rain Coat'}>
                                <Input value={data.rainCoat} disabled />
                            </Form.Item>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Form.Item name={'odometer'} label={'Odometer'}>
                                <Input value={data.odometer} disabled />
                            </Form.Item>
                        </Grid>
                        <Grid item xs={6}>
                            <Form.Item name={'barPetrol'} label={'Bar Petrol'}>
                                <Input value={data.barPetrol} disabled />
                            </Form.Item>
                        </Grid>
                    </Grid>
                </Form>
                <Typography variant='h4' style={{ color: primaryColor }}>
                    Deskripsi
                </Typography>
                <Grid container>
                    <Grid item xs={12}>
                        <TextArea onChange={(e) => setDescription(e.target.value)} value={description} rows={3} />
                    </Grid>
                </Grid>
            </div>
        </Modal>
    );
};

export default ModalDescription;